'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { signUp } from "../requests/user"
import { SignUpData } from "@/interfaces/api/signup/api_request_types"
import { API_Data_SignUp_Response } from "@/interfaces/api/signup/api_response_types"

export const useSignUp = () => useMutation<API_Success_Response<API_Data_SignUp_Response>, API_Error, { basicAuth: string, payload: SignUpData }>({
    retry: false,
    mutationFn: signUp
})